import * as React from "react";
import styled from "styled-components";
import { Button } from "@mui/material";

const MissingConfigNotificationStyles = styled.div`
  width: 100%;
  padding-top: 10vh;
  text-align: center;

  .continue-button-container {
    padding-top: 5vh;
  }
`;

export interface MissingConfigNotificationProps {
  /**
   * A function that is called when the retry button is pressed. This should
   * try to load the config again. E.g., use the WinRT API to load a local
   * file.
   */
  onClickRetry(): void;
}

/**
 * A component to notify users that config is missing (or perhaps incomplete).
 */
export const MissingConfigNotification = ({
  onClickRetry,
}: MissingConfigNotificationProps): React.JSX.Element => (
  <MissingConfigNotificationStyles>
    <div>
      config.json missing or incomplete
      {/* <code>{Windows.Storage.ApplicationData.current.localFolder.path}</code> */}
    </div>
    <div className="continue-button-container">
      <Button variant="contained" onClick={() => onClickRetry()}>
        Continue
      </Button>
    </div>
  </MissingConfigNotificationStyles>
);
